






import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

@Component({})
export default class TableLogoHeader extends Vue {
  // eslint-disable-next-line global-require
  activeIcon = require('@/assets/icons/PICTO_LIGNE_TURQUOISE.svg');

  // eslint-disable-next-line global-require
  inactiveIcon = require('@/assets/icons/PICTO_LIGNE_VIOLET.svg');

  @Prop({ type: String, required: true })
  readonly title!: string;

  @Prop({ type: Boolean, required: true, default: true })
  readonly isActive!: boolean;

  get compIcon(): string {
    return this.isActive ? this.activeIcon : this.inactiveIcon;
  }

  get compTextStyle(): string {
    return `table-header-title-${this.isActive ? 'active' : 'inactive'}`;
  }
}
